import { useState, useEffect } from 'react';

export const useParallax = (ref) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (ref.current) {
        const { clientWidth, clientHeight } = document.documentElement;
        const moveX = (e.clientX - clientWidth / 2) / 40;
        const moveY = (e.clientY - clientHeight / 2) / 40;
        setPosition({ x: moveX, y: moveY });
      }
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [ref]);

  useEffect(() => {
    if (ref.current) {
      ref.current.style.transform = `translate(${position.x}px, ${position.y}px)`;
      ref.current.style.transition = 'transform 0.1s linear';
    }
  }, [position, ref]);
};
